export default "__VITE_ASSET__Ehn9aZ_4__"